import React, {FunctionComponent, HTMLAttributes} from "react";
import clsx from "clsx";
import {MCDisabledColor} from "../question/common/questionConstants";
import {createUseStyles} from "react-jss";
import {Theme} from "engage-client/theme";

export enum Direction {
    Up,
    Down
}

type AnswerDistributionLabelProps = HTMLAttributes<HTMLDivElement> & {
    direction: Direction
    color: string
}

const BorderColor = "#04304B";
const DisabledBorderColor = "#626262";

const useStyles = createUseStyles<Theme>((theme) => ({
    answerCount: (props) => ({
        display: "flex",
        justifyContent: "center",
        position: "absolute",
        zIndex: 1,
        textAlign: "center",
        transform: "translateX(-50%)",
        background: props.color,
        border: `2px solid ${props.color !== MCDisabledColor ? BorderColor : DisabledBorderColor}`,
        borderRadius: 4,
        color: "#fff",
        minWidth: 48,
        [theme.breakpoints.only("xs")] : {
            padding: "1px 0",
        },
        "&:before": {
            position: "absolute",
            display: "inline-block",
            content: '" "',
            border: "7px solid transparent",
            margin: "0 auto",
            width: 0,
            left: 0,
            right: 0
        },
        "&:after": {
            position: "absolute",
            display: "inline-block",
            content: '" "',
            border: "6px solid transparent",
            margin: "0 auto",
            width: 0,
            left: 0,
            right: 0
        }
    }),
    answerTop: (props) => ({
        top: -14,
        "&:before": {
            bottom: -14,
            borderTopColor: props.color !== MCDisabledColor ? BorderColor : DisabledBorderColor,
        },
        "&:after": {
            bottom: -10,
            borderTopColor: props.color,
        }
    }),
    answerBottom: (props) => ({
        top: -8,
        "&:before": {
            top: -14,
            borderBottomColor: props.color !== MCDisabledColor ? BorderColor : DisabledBorderColor,
        },
        "&:after": {
            top: -10,
            borderBottomColor: props.color,
        }
    })
}));

export const AnswerDistributionLabel:FunctionComponent<AnswerDistributionLabelProps> = ({children,
                                                                                            color,
                                                                                            direction, ...other}) => {
    const classes = useStyles({color: color});
    return <div className={clsx(classes.answerCount,
        direction === Direction.Down && classes.answerTop,
        direction === Direction.Up && classes.answerBottom,
        other.className)} {...other}>
        {children}
        </div>;
};